"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderMobile = void 0;
var React = require("react");
var format_1 = require("@/utils/format");
var classNames = require("classnames");
var StampdutyHelper_1 = require("@/pages/stampduty/components/StampdutyHelper");
exports.renderMobile = function (props) {
    var renderValue = function (value) {
        if (StampdutyHelper_1.stampDutyHelper.isString(value)) {
            return (React.createElement("div", { className: "c-stampduty__value" }, format_1.default.stripTag(value)));
        }
        if (StampdutyHelper_1.stampDutyHelper.isStringArray(value)) {
            return (React.createElement("div", { className: "c-stampduty__value" }, value.map(function (it, i) { return (React.createElement("p", { key: i }, format_1.default.stripTag(it))); })));
        }
        if (StampdutyHelper_1.stampDutyHelper.isSubitem(value)) {
            var RF_1 = React.Fragment;
            var renderSub_1 = function (sub) { return (React.createElement(React.Fragment, null,
                format_1.default.stripTag(sub.item),
                React.createElement("br", null),
                sub.subItems.map(function (it, i) { return (React.createElement(RF_1, { key: i },
                    format_1.default.stripTag(it),
                    React.createElement("br", null))); }))); };
            return (React.createElement("div", { className: "c-stampduty__value" }, value.map(function (it, i) { return (React.createElement("p", { key: i }, renderSub_1(it))); })));
        }
        if (StampdutyHelper_1.stampDutyHelper.isAmountValue(value)) {
            var renderTable = function (rows) {
                var renderRow = function (row, i) { return (React.createElement("tr", { key: i },
                    React.createElement("td", null, format_1.default.stripTag(row.range)),
                    React.createElement("td", null, format_1.default.stripTag(row.amount)))); };
                var classname = classNames([
                    'c-stampduty__table', 'c-stampduty__table--nocenter',
                ]);
                return (React.createElement("table", { className: classname },
                    React.createElement("tbody", null, rows.map(function (it, i) { return renderRow(it, i); }))));
            };
            return (React.createElement("div", { className: "c-stampduty__value" },
                React.createElement("p", { className: "l-pad" }, format_1.default.stripTag(value.purchaseAmountOrValue)),
                renderTable(value.items)));
        }
    };
    var renderRow = function (row, i) { return (React.createElement("div", { key: i, className: "c-stampduty__row" },
        React.createElement("div", { className: "c-stampduty__label" }, row.label),
        renderValue(row.value))); };
    var renderRows = function (rows) { return (React.createElement("div", { className: "c-stampduty__rows" }, rows.map(function (it, i) { return renderRow(it, i); }))); };
    var renderBlock = function (title, rows) {
        return (React.createElement("div", { className: "c-stampduty__block c-stampduty__relative" },
            React.createElement("div", { className: "c-stampduty__watermark" }, "OKAY.COM"),
            React.createElement("div", { className: "c-stampduty__title" }, format_1.default.stripTag(title)),
            renderRows(rows)));
    };
    var renderSection = function (t, stampDuty) { return renderBlock(stampDuty.name, [
        {
            label: t.transactionsAffected,
            value: stampDuty.transactionsAffected,
        },
        {
            label: t.responsibleForPayment,
            value: stampDuty.responsibleForPayment,
        },
        {
            label: t.effectiveDates,
            value: stampDuty.effectiveDates,
        },
        {
            label: t.paymentAmount,
            value: stampDuty.paymentAmount,
        },
        {
            label: t.exemptions,
            value: stampDuty.exemptions,
        },
    ]); };
    var t = props.contentSection.translate;
    var regular = props.contentSection.stampDutyList.regularStampDuty;
    var ssd = props.contentSection.stampDutyList.specialStampDuty;
    var bsd = props.contentSection.stampDutyList.buyersStampDuty;
    var avd = props.contentSection.stampDutyList.adValoremStampDuty;
    return (React.createElement("div", { className: "c-stampduty__blocks" },
        renderSection(t, regular),
        renderSection(t, ssd),
        renderSection(t, bsd),
        renderSection(t, avd)));
};
